<template>
  <el-footer style="height:60px;align-items:center">
    <el-row type="flex" class="row-footer" justify="center" style="width: 1200px;margin: auto">
      <el-col :span="3" style="padding: 10px 0">
        <a href="https://www.revolvermaps.com/livestats/5ii7xfawt0l/"><img src="//rf.revolvermaps.com/w/3/s/a/4/0/2/ffffff/010020/aa0000/5ii7xfawt0l.png" alt="Stats" style="border:0;"></a>
      </el-col>
      <el-col :span="21">
        <div class="logo">
          <a href="#" style="text-align:left">
            <img src="@/assets/img/logo.svg" alt="HumPoPG-logo" class="navlogo" width="100px" style="margin-top:8px">
          </a>
          <p>2022 © All Rights Reserved by Human Population Omics Group</p><br>
        </div>
      </el-col>

    </el-row>
  </el-footer>
</template>

<script>
export default {
  name: 'Navbar'
}
</script>

<style scoped>
    .el-footer {
        left: 0;
        bottom: 0;
        padding: 0px;
        margin: 0px;
        width: 100%;
        background: #F8FBFD;
    }
    p {
      text-align: left;
      font-size: 15px;
    }
    .logo {
      text-align: left;
    }

</style>
